import styled from "styled-components";

const DescriptionGridStyled = styled.div<{ $colSpan: number }>`
    display: grid;
    grid-template-columns: repeat(${({ $colSpan }) => $colSpan}, minmax(min-content, auto));
    gap: 1rem;
`;

type Props = {
    children?: React.ReactNode;
    colSpan?: number;
};

const DescriptionGrid = (props: Props) => {
    return <DescriptionGridStyled $colSpan={props.colSpan ?? 1}>{props.children}</DescriptionGridStyled>;
};

export { DescriptionGrid };
